import { CreateSubscriptionV3Interface } from "../interfaces/SubscriptionV3interfaces/CreateSubscriptionV3Interface";
import { SubscriptionV3Interface } from "../interfaces/SubscriptionV3interfaces/subscriptionV3";
import BaseService from "./BaseService";

export class SubscriptionV3Service extends BaseService<SubscriptionV3Interface, CreateSubscriptionV3Interface>{ 
    constructor(){
        let url: string = '/subscription/v3/admin'
        super(url)
    }
}